export default __webpack_public_path__ + "static/media/Wheel-Green.99322233.png";